import AddButton from 'components/buttons/AddButton'
import Loader from 'components/loader/Loader'
import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'
import { connect } from 'react-redux';
import { ModuleListRes, ModuleListTodo } from 'redux/slice/super-admin/module/ModuleList';
import ModuleAction from 'components/data-table/data-table-action/superadmin-actions/ModuleAction';
import DataTable from 'components/data-table/DataTable';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

 class ModuleList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            bool: false
        };
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.setState({ loading: true });
        dispatch(ModuleListTodo()).then(() => this.List_res());
    }

    componentDidUpdate(prevProps, prevState) {
        const { dispatch } = this.props;
        if (prevState.bool !== this.state.bool) {
            dispatch(ModuleListTodo()).then(() => this.List_res());
        }
    }

    setBool = () => {
        this.setState(prevState => ({ bool: !prevState.bool }));
    }

    List_res = () => {
        if (ModuleListRes?.status) {
            this.setState({ loading: false });
        } else {
            this.setState({ loading: false });
        }
    }
    render() {

        const { loading, bool } = this.state;
        const { moduleList } = this.props;
        const columnDefs = [
            {
                headerName: 'S.NO',
                valueGetter: 'node.rowIndex + 1',
                filter: 'false',
                suppressMenu: true,
                sortable: true,
                floatingFilter: false,
                maxWidth: 90
            },
            {
                headerName: 'MODULE',
                field: 'module_display_name',
                filter: 'agTextColumnFilter',
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
            },
       

            {
                headerName: 'PRIORITY',
                field: 'module_priority',
                filter: 'agTextColumnFilter',
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
            },
          
            {
                headerName: 'STATUS',
                field: 'status',
                filter: 'agTextColumnFilter',
                // cellRenderer: params => (
                //     <span className={params.value === 'Active' ? 'badge bg-success' : 'badge bg-danger'}>
                //         {params.value}
                //     </span>
                // ),
                cellRenderer: params => params.value === 'Active' ? <span className='active-status'>Active</span> : <span className='inactive-status'>Inactive</span>,
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
                maxWidth: 120
            },
            {
                field: 'ACTIONS',
                cellRenderer: ModuleAction,
                cellRendererParams: {
                    bool: bool,
                    setBool: this.setBool,
                },
                autoHeight: true,
                pinned: 'right',
                maxWidth: 120,
            }
        ];
        return (
            <>
                <div className="page-content">
                    <Container fluid>
                        <div className='d-flex justify-content-between align-items-center'>
                            <h4 className="mb-0 font-size-18">Module List</h4>
                            <Link to='/superadmin/add-module'> <AddButton name={"ADD MODULE"} /></Link>
                        </div>
                        <Row>
                            <Col xl='12' className='mt-2'>
                                {loading ?
                                    <div className='dd-flex justify-content-center p-5'>
                                        <Loader />
                                    </div> :
                                    moduleList?.length ?
                                        <DataTable
                                            rowData={moduleList}
                                            columnDefs={columnDefs}
                                            height={'70vh'}
                                        />
                                        :
                                        <div className='empty_section'>
                                            <h4>DATA NOT FOUND</h4>
                                        </div>}
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
const mapStateToProps = state => ({
    moduleList: state?.ModuleList?.data?.data,
    // departmentListRes: state.DepartmentListRes // Adjust based on where `departmentListRes` is stored
});
export default connect(mapStateToProps)(ModuleList)
